import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { careerAndSeasonStatsNavSelector } from 'store/modules/statspro/career-and-season-stats/selectors';
import { UPDATE_NAV_ITEM } from 'store/modules/statspro/career-and-season-stats/actions';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';

export const CategoryNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(careerAndSeasonStatsNavSelector);

    return (
        <Select
            items={STATS_CATEGORY_ARRAY}
            initialSelectedItem={nav.category}
            activeItem={nav.category}
            label={getTranslation('label.statsLeaders.nav.category')}
            onSelectedItemChange={({ selectedItem }) => {
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'category',
                        value: selectedItem
                    })
                );
            }}
        />
    );
};
